import { Component, OnInit } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { TokenService } from 'src/app/authentication/services/token.service';

@Component({
	selector: 'app-menu',
	template: `
		<ul class="layout-menu">
			<li app-menuitem *ngFor="let item of model; let i = index" [item]="item" [index]="i" [root]="true"></li>
		</ul>
	`,
})
export class AppMenuComponent implements OnInit {
	model: any[];
	rol: string;

	constructor(public app: AppComponent, private autService: TokenService) { }

	ngOnInit() {
		this.rol = this.autService.getUserLoggedIn().rol;

		this.model = [
			{
				label: 'Favoritos',
				icon: 'pi pi-fw pi-home',
				items: [
					//{ label: 'Dashboard', icon: 'pi pi-fw pi-home', routerLink: ['/home'] },
					{ label: 'A.Precisión', icon: 'pi pi-fw pi-star', routerLink: ['/mis-equipos/raven'] },
					{ label: 'Estado Actual', icon: 'pi pi-fw pi-check', routerLink: ['/mis-equipos'] },
				],
			},
			
			{
				label: 'Telemetría',
				icon: 'pi pi-fw pi-star',
				items: [{ label: 'Mapa', icon: 'pi pi-fw pi-desktop', routerLink: ['/mis-equipos/mapa'] }],
			},
			{
				label: 'Reportes',
				icon: 'pi pi-fw pi-compass',
				routerLink: [''],
				items: [
					{
						label: 'Estados ',
						icon: 'pi pi-fw pi-desktop',
						routerLink: ['/mis-equipos/mis-reportes']
					},
					{
						label: 'Datos ',
						icon: 'pi pi-fw pi-external-link',
						routerLink: ['/mis-equipos/mis-reportes-velocidad'],
					},
					{
						label: 'Fallas y eventos',
						icon: 'pi pi-fw pi-directions',
						routerLink: ['/mis-equipos/mis-reportes-eventos'],
					},
				],
			},
		];

		if (this.rol === 'AdminEmpresa') {
			this.model.push({
				label: 'Configuración',
				icon: 'pi pi-fw pi-compass',
				items: [
					{
						label: 'Usuarios',
						icon: 'pi pi-fw pi-external-link',
						routerLink: ['/usuarios'],
					},
					{
						label: 'Fallas y eventos',
						icon: 'pi pi-fw pi-directions',
						routerLink: ['/equipos/eventos'],
					},
					{
						label: 'Conf. Reportes',
						icon: 'pi pi-fw pi-directions',
						routerLink: ['/equipos/reportescnf'],
					},
				],
			});
		}

		if (this.rol === 'Admin') {
			this.model.push({
				label: 'Configuración',
				icon: 'pi pi-fw pi-compass',
				items: [
					{
						label: 'Usuarios',
						icon: 'pi pi-fw pi-external-link',
						routerLink: ['/usuarios'],
					},
					{
						label: 'Fallas y eventos',
						icon: 'pi pi-fw pi-directions',
						routerLink: ['/equipos/eventos'],
					},
					{
						label: 'Conf. Reportes',
						icon: 'pi pi-fw pi-directions',
						routerLink: ['/equipos/reportescnf'],
					},
					{
						label: 'Empresas',
						icon: 'pi pi-fw pi-directions',
						routerLink: ['/empresas'],
					},
				],
			});
		}
	}
}
